import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../../App.css";
import { Box, Button, Card, Typography } from "@mui/material";
import { getMenuCardBuilderBucks } from "../common/GetMenuCardBuilderBucks";
import { useLocation, useNavigate } from "react-router-dom";
import { English } from "../../constant/EnglishFallback";
import bucksIcon from "../../assets/images/bucks.png";
import { BIBlue, BIGrey } from "../../assets/helpers";

function BuilderBucksBalance() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { loginData, menuCardBuilderBucks, multiLanguageData } = useSelector(
    (state) => state?.main
  );
  const LanguageData = multiLanguageData?.RewardStore || {};
  const {
    TEXT_YOUR_BALANCE = English.RewardStore.TEXT_YOUR_BALANCE,
    BUTTON_REDEEM = English.RewardStore.BUTTON_REDEEM
  } = LanguageData || {};

  useEffect(() => {
    if (loginData?.userInformation?.UserId && loginData?.accessToken) {
      dispatch(getMenuCardBuilderBucks(loginData.userInformation.UserId, loginData.accessToken));
    }
  }, [dispatch, loginData?.accessToken, loginData?.userInformation?.UserId]);

  const goToActivity = () => {
    navigate("/reward-store/my-store");
  };

  return (
    <div>
      <Card
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "16px",
          border: "1px solid #e0e0e0",
          borderRadius: "12px",
          boxShadow: "0px 4px 12px rgba(0,0,0,0.05)",
          backgroundColor: "#ffffff",
        }}
      >
        {/* Left content */}
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: 'center' }}>
          <Typography variant="body2" style={{ color: BIGrey }}>
            {TEXT_YOUR_BALANCE.replace(":", "")}
          </Typography>
          <Typography variant="h5" sx={{ fontWeight: "bold" }} style={{ color: BIBlue, display: 'flex', alignItems: 'center', gap: 3 }}>
            <span id="buckBalance">{menuCardBuilderBucks?.bucks ?? 0}</span>{" "}
            <img src={bucksIcon} alt="Builder Bucks" style={{ width: 20, height: 30, verticalAlign: 'middle', marginLeft: 4 }} />
          </Typography>
        </Box>

        {/* Redeem button */}
        {!location.pathname.includes("/my-store") && <Button
          variant="contained"
          sx={{
            background: BIBlue,
            borderRadius: "8px",
            paddingX: 2,
            paddingY: 1,
            fontWeight: "bold",
            textTransform: "none",
            boxShadow: "none",
            cursor: "pointer",
            "&:hover": { boxShadow: "0px 4px 12px rgba(0,0,0,0.1)" },
          }}
          onClick={goToActivity}
        >
          {BUTTON_REDEEM}
        </Button>}
      </Card>
    </div>

  );
}

export default BuilderBucksBalance;
